module.exports = __webpack_public_path__ + "static/media/rtds team2-10.ac1e073c.png";


//////////////////
// WEBPACK FOOTER
// ./src/rtds team2-10.png
// module id = 208
// module chunks = 0